import { render, staticRenderFns } from "./SidebarNav.vue?vue&type=template&id=c0d32aa8&scoped=true"
import script from "./SidebarNav.vue?vue&type=script&lang=js"
export * from "./SidebarNav.vue?vue&type=script&lang=js"
import style0 from "./SidebarNav.vue?vue&type=style&index=0&id=c0d32aa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d32aa8",
  null
  
)

export default component.exports